<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Data'
}
</script>

<style>

</style>